export const CATEGORY_ALL = 'All'